























import { Folder } from "@/domain/folder";
import { PasswordCreator } from "@/infrastructure/utilities";
import { Mixins, Component, Model, Prop, Watch, Emit } from "vue-property-decorator";

@Component
export default class FolderEditDialog extends Mixins() {
  @Model("input")
  isVisible: boolean;

  @Prop()
  isEdit: boolean;

  @Prop()
  editSource: Folder;

  data() {
    return {
      visible: false,
      comment: "",
      password: "",
      published: true,
    };
  }
  visible: boolean;
  comment: string;
  password: string;
  published: boolean;

  get title(): string {
    return this.isEdit
      ? "フォルダ編集"
      : "フォルダ追加";
  }

  get confirmEnabled(): boolean {
    return !!this.comment && (!this.isEdit || !!this.password) ;
  }

  onCancel(): void {
    this.visible = false;
  }

  onConfirm(): void {
    if (!this.isEdit) {
      // フォルダ追加は自動でパスワードを生成
      this.onCreatePassword();
    }

    const folder = this.isEdit ? this.editSource.clone() : new Folder();
    folder.comment = this.comment;
    folder.password = this.password;
    folder.published = this.published;

    this.confirm(folder);
    this.visible = false;
  }

  onCreatePassword(): void {
    this.password = PasswordCreator.getPassword();
  }

  @Watch("isVisible")
  onIsVisibleUpdated(newValue: boolean, oldValue: boolean): void {
    if (newValue) {
      if (this.isEdit) {
        this.comment = this.editSource.comment as string;
        this.password = this.editSource.password as string;
        this.published = this.editSource.published;
      } else {
        this.comment = "";
        this.password = "";
        this.published = true;
      }
    }
    this.visible = newValue;
  }

  @Watch("visible")
  onVisibleUpdated(newValue: boolean, oldValue: boolean): void {
    this.input(newValue);
  }

  @Emit()
  confirm(value: Folder): void {}

  @Emit()
  input(value: boolean): void {}
}
